import { style } from '@vanilla-extract/css'

const section = style({
  backgroundColor: 'white',
})

const thumbnail = style({
  borderRadius: '24px',
  maxWidth: '376px',
  width: '100%',
  cursor: 'pointer',
})

export const styles = {
  section,
  thumbnail,
}
